import { notification } from 'antd'
export const savePkgNoti = (type, message, description) => {
  const notiStyle = {
    background: type === 'error' ? '#fef0ef' : '#ebf8f2',
    border: type === 'error' ? 'solid 1px #fabeb9' : 'solid 1px #a7e1c4',
    lineHeight: 1.5,
    letterSpacing: -0.5,
  }

  notification[type]({
    message: (
      <div style={{ color: 'rgba(0, 0, 0, 0.75)', fontSize: 14 }}>
        {message}
      </div>
    ),
    description: (
      <div style={{ fontSize: 12 }}>
        {description.split('\n').map((line) => (
          <span key={line}>
            {line}
            <br />
          </span>
        ))}
      </div>
    ),
    duration: 10,
    className: 'custom-notification',
    style: notiStyle,
  })
}
